(function () {
  var scrollLockY = 0;

  function lockPageScroll() {
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.body.classList.add('tcb-scroll-locked');
    document.body.style.top = '-' + scrollLockY + 'px';
  }

  function unlockPageScroll() {
    document.body.classList.remove('tcb-scroll-locked');
    document.body.style.top = '';
    window.scrollTo(0, scrollLockY);
  }

  var cartToastTimer = null;

  function cartRoute(path) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return base.replace(/\/$/, '') + path;
  }

  function showCartToast(title, text) {
    var toast = document.querySelector('[data-tcb-cart-toast]');
    if (!toast) return;
    var titleEl = toast.querySelector('[data-tcb-cart-toast-title]');
    var textEl = toast.querySelector('[data-tcb-cart-toast-text]');
    if (titleEl) titleEl.textContent = title || 'Added to cart';
    if (textEl) textEl.textContent = text || '';
    toast.hidden = false;
    void toast.offsetWidth;
    toast.classList.add('is-visible');
    if (cartToastTimer) clearTimeout(cartToastTimer);
    cartToastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 4000);
  }

  function refreshCartCount() {
    fetch(cartRoute('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart && typeof cart.item_count === 'number' ? cart.item_count : null;
        if (count === null) return;

        document.querySelectorAll('[data-tcb-cart-count], .header__cart-count').forEach(function (el) {
          el.textContent = count;
          if (el.hasAttribute('data-tcb-cart-count')) {
            el.hidden = count === 0;
          }
        });

        var miniCart = document.getElementById('mini-cart');
        if (miniCart) miniCart.setAttribute('data-item-count', String(count));

        var drawerTitle = document.querySelector('.tcb-cart-drawer__title');
        if (drawerTitle) {
          var sup = drawerTitle.querySelector('sup');
          if (count > 0) {
            if (sup) sup.textContent = count;
            else drawerTitle.insertAdjacentHTML('beforeend', '<sup>' + count + '</sup>');
          } else if (sup) {
            sup.remove();
          }
        }
      })
      .catch(function () {});
  }

  function notifyCartUpdated(btn, quantity) {
    document.dispatchEvent(new CustomEvent('tcb:cart-updated'));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: { scrollToTop: false }
    }));
    refreshCartCount();
  }

  function tcbQuickAdd(form, btn, opts) {
    opts = opts || {};
    var resetLabel = opts.resetLabel || (btn ? btn.textContent : 'Add');
    var fd = new FormData(form);
    var title = (btn && btn.getAttribute('data-tcb-product-title')) || '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Adding…';
    }
    fetch(cartRoute('/cart/add.js'), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok) {
          if (btn) {
            btn.textContent = 'Unavailable';
            setTimeout(function () { btn.disabled = false; btn.textContent = resetLabel; }, 1800);
          }
          showCartToast('Not added', (res.data && res.data.description) || 'Could not add to cart.');
          return;
        }
        if (btn) {
          btn.textContent = 'Added ✓';
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = resetLabel;
          }, 1800);
        }
        showCartToast('Added to cart', title);
        notifyCartUpdated(btn, parseInt(fd.get('quantity'), 10) || 1);
      })
      .catch(function () {
        form.submit();
      });
  }

  function bindQuickAddForms(root, formSelector, btnSelector, resetLabel) {
    root.querySelectorAll(formSelector).forEach(function (form) {
      if (form.getAttribute('data-bound') === '1') return;
      form.setAttribute('data-bound', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        tcbQuickAdd(form, form.querySelector(btnSelector), { resetLabel: resetLabel });
      });
    });
  }

  function portalOverlay(el) {
    if (!el || el.getAttribute('data-tcb-portaled') === '1') return;
    document.body.appendChild(el);
    el.setAttribute('data-tcb-portaled', '1');
  }

  function normalizeModelSrc(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    return src;
  }

  function initGallery(root) {
    var gallery = root.querySelector('[data-tcb-gallery]');
    if (!gallery || gallery.getAttribute('data-bound') === '1') return;
    gallery.setAttribute('data-bound', '1');

    var imageSlides = Array.prototype.slice.call(gallery.querySelectorAll('[data-slide-type="image"]'));
    var thumbs = gallery.querySelectorAll('.tcb-thumb:not(.tcb-thumb--video):not(.tcb-thumb--3d)');
    var prevBtn = gallery.querySelector('[data-tcb-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-tcb-gallery-next]');
    var zoomBtn = gallery.querySelector('[data-tcb-gallery-zoom]');
    var lightbox = root.querySelector('[data-tcb-gallery-lightbox]');
    var lightboxImg = lightbox ? lightbox.querySelector('[data-tcb-lightbox-img]') : null;
    var videoModal = root.querySelector('[data-tcb-video-modal]');
    var videoIframe = videoModal ? videoModal.querySelector('[data-tcb-video-modal-iframe]') : null;
    var model3dModal = root.querySelector('[data-tcb-3d-modal]');
    var model3dLoaded = false;
    var assetModelSrc = '';
    var currentIndex = 0;
    var savedImageIndex = 0;

    portalOverlay(lightbox);
    portalOverlay(videoModal);
    portalOverlay(model3dModal);

    function getVideoSrc(trigger) {
      if (trigger && trigger.getAttribute('data-video-src')) {
        return trigger.getAttribute('data-video-src');
      }
      return gallery.getAttribute('data-video-src') || '';
    }

    function openVideoModal(trigger) {
      if (!videoModal || !videoIframe) return;
      var src = getVideoSrc(trigger);
      if (!src) return;
      savedImageIndex = currentIndex;
      videoIframe.setAttribute('src', src);
      videoModal.hidden = false;
      videoModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tcb-video-modal-open');
      lockPageScroll();
      var closeBtn = videoModal.querySelector('.tcb-video-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeVideoModal() {
      if (!videoModal || videoModal.hidden) return;
      videoModal.hidden = true;
      videoModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcb-video-modal-open');
      if (videoIframe) videoIframe.removeAttribute('src');
      unlockPageScroll();
      showImage(savedImageIndex);
    }

    function ensureModelViewerLoaded(callback) {
      if (model3dLoaded) {
        if (callback) callback();
        return;
      }
      var stylesheet = document.querySelector('link[data-tcb-model-viewer-css]');
      if (!stylesheet) {
        stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = 'https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css';
        stylesheet.setAttribute('data-tcb-model-viewer-css', '1');
        document.head.appendChild(stylesheet);
      }
      var moduleScript = document.querySelector('script[data-tcb-model-viewer-module]');
      if (!moduleScript) {
        moduleScript = document.createElement('script');
        moduleScript.type = 'module';
        moduleScript.src = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.21/model-viewer.min.js';
        moduleScript.setAttribute('data-tcb-model-viewer-module', '1');
        moduleScript.onload = function () {
          model3dLoaded = true;
          if (callback) callback();
        };
        moduleScript.onerror = function () {
          var fallback = document.createElement('script');
          fallback.type = 'module';
          fallback.src = 'https://unpkg.com/@google/model-viewer/dist/model-viewer.min.js';
          fallback.setAttribute('data-tcb-model-viewer-module', '1');
          fallback.onload = function () {
            model3dLoaded = true;
            if (callback) callback();
          };
          document.head.appendChild(fallback);
        };
        document.head.appendChild(moduleScript);
        return;
      }
      if (window.customElements && window.customElements.get('model-viewer')) {
        model3dLoaded = true;
        if (callback) callback();
        return;
      }
      setTimeout(function () { ensureModelViewerLoaded(callback); }, 100);
    }

    function configureAssetModelButtons() {
      var dataEl = document.getElementById('tcb-3d-models-data');
      if (!dataEl || !gallery) return;
      var handle = gallery.getAttribute('data-product-handle') || '';
      var map = {};
      try { map = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
      assetModelSrc = normalizeModelSrc(map[handle] || '');
      if (!assetModelSrc) return;
      gallery.querySelectorAll('[data-tcb-view-3d-asset]').forEach(function (btn) {
        btn.hidden = false;
      });
      var actions = gallery.querySelector('[data-tcb-media-actions]');
      if (actions) actions.hidden = false;
    }

    function activateAssetModelViewer(viewer) {
      if (!viewer || !assetModelSrc) return;
      var src = normalizeModelSrc(assetModelSrc);
      viewer.setAttribute('reveal', 'auto');
      viewer.setAttribute('camera-controls', '');
      viewer.setAttribute('touch-action', 'pan-y');
      if (viewer.getAttribute('src') !== src) {
        viewer.removeAttribute('src');
        viewer.setAttribute('src', src);
      }
    }

    function open3dModal() {
      if (!model3dModal) return;
      savedImageIndex = currentIndex;
      ensureModelViewerLoaded(function () {
        model3dModal.hidden = false;
        model3dModal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('tcb-3d-modal-open');
        lockPageScroll();
        var closeBtn = model3dModal.querySelector('.tcb-3d-modal__close');
        if (closeBtn) closeBtn.focus();
        var viewer = model3dModal.querySelector('model-viewer, [data-tcb-model-viewer]');
        if (viewer && viewer.hasAttribute('data-tcb-model-viewer')) {
          activateAssetModelViewer(viewer);
        }
        if (viewer && typeof viewer.focus === 'function') {
          setTimeout(function () { viewer.focus(); }, 50);
        }
      });
    }

    function close3dModal() {
      if (!model3dModal || model3dModal.hidden) return;
      model3dModal.hidden = true;
      model3dModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcb-3d-modal-open');
      unlockPageScroll();
      showImage(savedImageIndex);
    }

    function imageSources() {
      return imageSlides.map(function (slide) {
        var img = slide.querySelector('[data-tcb-main-img], .tcb-main-img');
        if (!img) return '';
        return img.getAttribute('data-zoom-src') || img.getAttribute('src') || '';
      });
    }

    function showImage(index) {
      if (!imageSlides.length) return;
      if (index < 0) index = imageSlides.length - 1;
      if (index >= imageSlides.length) index = 0;
      currentIndex = index;
      imageSlides.forEach(function (slide, i) {
        var active = i === index;
        slide.hidden = !active;
        slide.classList.toggle('is-active', active);
      });
      gallery.querySelectorAll('.tcb-thumb:not(.tcb-thumb--video):not(.tcb-thumb--3d)').forEach(function (thumb) {
        var thumbIndex = thumb.getAttribute('data-thumb-index');
        var active = thumbIndex === String(index);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      var videoThumb = gallery.querySelector('.tcb-thumb--video');
      if (videoThumb) {
        videoThumb.classList.remove('is-active');
        videoThumb.setAttribute('aria-selected', 'false');
      }
      var modelThumb = gallery.querySelector('.tcb-thumb--3d');
      if (modelThumb) {
        modelThumb.classList.remove('is-active');
        modelThumb.setAttribute('aria-selected', 'false');
      }
    }

    function openLightbox(index) {
      if (!lightbox || !lightboxImg) return;
      var sources = imageSources();
      if (!sources.length) return;
      var idx = typeof index === 'number' ? index : currentIndex;
      lightboxImg.src = sources[idx] || sources[0];
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tcb-lightbox-open');
      lockPageScroll();
      lightbox.setAttribute('data-lightbox-index', String(idx));
    }

    function closeLightbox() {
      if (!lightbox || lightbox.hidden) return;
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcb-lightbox-open');
      unlockPageScroll();
    }

    function lightboxStep(delta) {
      if (!lightbox || lightbox.hidden) return;
      var sources = imageSources();
      if (sources.length < 2) return;
      var idx = parseInt(lightbox.getAttribute('data-lightbox-index') || '0', 10) + delta;
      if (idx < 0) idx = sources.length - 1;
      if (idx >= sources.length) idx = 0;
      lightbox.setAttribute('data-lightbox-index', String(idx));
      if (lightboxImg) lightboxImg.src = sources[idx];
      showImage(idx);
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        showImage(currentIndex - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        showImage(currentIndex + 1);
      });
    }
    if (zoomBtn) {
      zoomBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openLightbox(currentIndex);
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        showImage(parseInt(thumb.getAttribute('data-thumb-index'), 10) || 0);
      });
    });

    var videoThumb = gallery.querySelector('.tcb-thumb--video');
    if (videoThumb) {
      videoThumb.addEventListener('click', function (e) {
        e.preventDefault();
        openVideoModal(videoThumb);
      });
    }

    var modelThumb = gallery.querySelector('.tcb-thumb--3d');
    if (modelThumb) {
      modelThumb.addEventListener('click', function (e) {
        e.preventDefault();
        open3dModal();
      });
    }

    gallery.querySelectorAll('[data-tcb-play-video]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openVideoModal(btn);
      });
    });

    gallery.querySelectorAll('[data-tcb-view-3d]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        open3dModal();
      });
    });

    if (lightbox) {
      lightbox.querySelectorAll('[data-tcb-lightbox-close]').forEach(function (el) {
        el.addEventListener('click', closeLightbox);
      });
      var lbPrev = lightbox.querySelector('[data-tcb-lightbox-prev]');
      var lbNext = lightbox.querySelector('[data-tcb-lightbox-next]');
      if (lbPrev) lbPrev.addEventListener('click', function () { lightboxStep(-1); });
      if (lbNext) lbNext.addEventListener('click', function () { lightboxStep(1); });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }

    if (videoModal) {
      videoModal.querySelectorAll('[data-tcb-video-close]').forEach(function (el) {
        el.addEventListener('click', closeVideoModal);
      });
    }

    if (model3dModal) {
      model3dModal.querySelectorAll('[data-tcb-3d-close]').forEach(function (el) {
        el.addEventListener('click', close3dModal);
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (videoModal && !videoModal.hidden) closeVideoModal();
        else if (model3dModal && !model3dModal.hidden) close3dModal();
        else if (lightbox && !lightbox.hidden) closeLightbox();
        return;
      }
      if (!lightbox || lightbox.hidden) return;
      if (e.key === 'ArrowLeft') lightboxStep(-1);
      if (e.key === 'ArrowRight') lightboxStep(1);
    });

    var stage = gallery.querySelector('.tcb-gallery-stage');
    if (stage) {
      stage.addEventListener('click', function (e) {
        if (e.target.closest('[data-tcb-play-video], [data-tcb-view-3d], .tcb-gallery-nav, .tcb-gallery-zoom-btn')) return;
        var img = e.target.closest('.tcb-main-img');
        if (!img) return;
        openLightbox(currentIndex);
      });
    }

    if (imageSlides.length) showImage(0);
    configureAssetModelButtons();
  }

  function initAssuranceModal(root) {
    var modal = root.querySelector('[data-tcb-assurance-modal]');
    if (!modal || modal.getAttribute('data-bound') === '1') return;
    modal.setAttribute('data-bound', '1');

    var titleEl = modal.querySelector('.tcb-assurance-modal__title');
    var leadEl = modal.querySelector('.tcb-assurance-modal__lead');
    if (titleEl && !titleEl.getAttribute('data-default-title')) {
      titleEl.setAttribute('data-default-title', titleEl.textContent.trim());
    }
    if (leadEl && !leadEl.getAttribute('data-default-lead')) {
      leadEl.setAttribute('data-default-lead', leadEl.textContent.trim());
    }

    function setModalSections(focus) {
      modal.querySelectorAll('[data-assurance-section]').forEach(function (section) {
        if (focus === 'freight') {
          section.hidden = section.getAttribute('data-assurance-section') !== 'freight';
        } else {
          section.hidden = false;
        }
      });
    }

    function resetModalHeader() {
      if (titleEl) titleEl.textContent = titleEl.getAttribute('data-default-title') || 'Before you buy';
      if (leadEl) leadEl.textContent = leadEl.getAttribute('data-default-lead') || '';
    }

    function openModal(focus) {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tcb-assurance-modal-open');

      if (focus === 'freight') {
        if (titleEl) titleEl.textContent = 'Freight & delivery requirements';
        if (leadEl) leadEl.textContent = 'Confirm receiving conditions before ordering commercial equipment.';
      } else {
        resetModalHeader();
      }

      setModalSections(focus);

      if (focus) {
        var section = modal.querySelector('[data-assurance-section="' + focus + '"]');
        if (section) {
          setTimeout(function () {
            section.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }, 50);
        }
      }
      var closeBtn = modal.querySelector('.tcb-assurance-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcb-assurance-modal-open');
      resetModalHeader();
      setModalSections('');
    }

    root.querySelectorAll('[data-tcb-assurance-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openModal(btn.getAttribute('data-assurance-focus'));
      });
    });
    modal.querySelectorAll('[data-tcb-assurance-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });

    root.__tcbOpenAssuranceModal = openModal;
    initPaymentTerms(root, openModal);
  }

  function normalizeShippingLeadTime(text) {
    if (!text) return '';
    return String(text)
      .replace(/receive your order\s*:?\s*/gi, '')
      .replace(/3\s*[\u2013\u2014-]\s*8/g, '3 to 8')
      .replace(/3\s*"[\x93\x94]\s*8/gi, '3 to 8')
      .replace(/"[\x93\x94]/g, ' to ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function formatShippingLeadTime(text) {
    text = normalizeShippingLeadTime(text);
    if (!text) return '';
    if (/estimated delivery|order today|arrives|get it by|receive by|deliver/i.test(text)) return text;
    if (/business day/i.test(text)) return text;
    if (/after order confirmation/i.test(text)) return text;
    var range = text.match(/^(\d+)\s+to\s+(\d+)$/i);
    if (range) {
      return range[1] + ' to ' + range[2] + ' business days after order confirmation (freight)';
    }
    return text;
  }

  function readEtaLeadText() {
    var slot = document.getElementById('tcb-delivery-app-slot');
    if (!slot) return '';

    var widget = slot.querySelector('.deliverydate.sb_delivery, .sb_delivery.deliverydate, .deliverydate');
    if (widget) {
      var widgetText = (widget.innerText || widget.textContent || '').replace(/\s+/g, ' ').trim();
      if (widgetText.length > 2) return formatShippingLeadTime(widgetText);
    }

    var etaValue = slot.querySelector('[data-tcb-eta-value]');
    if (etaValue && etaValue.textContent.trim()) {
      return formatShippingLeadTime(etaValue.textContent.trim());
    }

    if (slot.getAttribute('data-tcb-lead-time')) {
      return formatShippingLeadTime(slot.getAttribute('data-tcb-lead-time'));
    }

    return '';
  }

  function syncShippingLeadTime(root) {
    var target = root.querySelector('[data-tcb-shipping-lead-time]');
    if (!target) return;
    var fallback = target.getAttribute('data-tcb-shipping-lead-fallback') ||
      '3 to 8 business days after order confirmation (freight)';
    var next = readEtaLeadText() || fallback;
    if (target.textContent.trim() !== next) target.textContent = next;
  }

  function initShippingLeadTimeSync(root) {
    syncShippingLeadTime(root);

    var slot = document.getElementById('tcb-delivery-app-slot');
    if (slot && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        syncShippingLeadTime(root);
      });
      observer.observe(slot, { childList: true, subtree: true, characterData: true });
      setTimeout(function () { observer.disconnect(); }, 60000);
    }

    [400, 1200, 2500, 5000, 10000, 20000].forEach(function (ms) {
      setTimeout(function () { syncShippingLeadTime(root); }, ms);
    });

    document.addEventListener('tcb:variant-change', function () {
      setTimeout(function () { syncShippingLeadTime(root); }, 300);
    });
  }

  function initPaymentTerms(root, openAssuranceModal) {
    var wrap = root.querySelector('[data-tcb-payment-terms-wrap]');
    if (!wrap || wrap.getAttribute('data-bound') === '1') return;
    wrap.setAttribute('data-bound', '1');
    wrap.setAttribute('role', 'button');
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('aria-label', 'View financing and payment options');

    function openFinancing(e) {
      if (e) e.preventDefault();
      if (typeof openAssuranceModal === 'function') {
        openAssuranceModal('financing');
      }
    }

    wrap.addEventListener('click', openFinancing);
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openFinancing(e);
      }
    });

    neutralizePaymentHashLinks(root);
    window.setTimeout(function () { neutralizePaymentHashLinks(root); }, 1500);
    window.setTimeout(function () { neutralizePaymentHashLinks(root); }, 4000);
  }

  function neutralizePaymentHashLinks(root) {
    (root || document).querySelectorAll('a.shopify-payment-button__more-options[href="#"], more-payment-options-link a[href="#"]').forEach(function (link) {
      link.setAttribute('href', '#tcb-financing');
      link.classList.add('tcb-hash-action--visually-hidden');
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
    });
  }

  function initTrustModal(root) {
    var modal = root.querySelector('[data-tcb-trust-modal]');
    if (!modal || modal.getAttribute('data-bound') === '1') return;
    modal.setAttribute('data-bound', '1');
    var titleEl = modal.querySelector('[data-tcb-trust-modal-title]');
    var bodyEl = modal.querySelector('[data-tcb-trust-modal-body]');

    function openModal(title, body) {
      if (titleEl) titleEl.textContent = title || 'Details';
      if (bodyEl) bodyEl.textContent = body || '';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tcb-trust-modal-open');
      var closeBtn = modal.querySelector('.tcb-trust-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcb-trust-modal-open');
    }

    root.querySelectorAll('[data-tcb-trust-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.getAttribute('data-trust-title'), btn.getAttribute('data-trust-body'));
      });
    });
    modal.querySelectorAll('[data-tcb-trust-close]').forEach(function (el) {
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeModal();
    });
  }

  function initTrustBadgesLoadMore(root) {
    root.querySelectorAll('[data-tcb-trust-badges]').forEach(function (wrap) {
      if (wrap.getAttribute('data-bound') === '1') return;
      wrap.setAttribute('data-bound', '1');
      var toggle = wrap.querySelector('[data-tcb-trust-badges-toggle]');
      if (!toggle) return;
      var total = parseInt(wrap.getAttribute('data-tcb-trust-badges-total') || '0', 10);
      var initial = parseInt(wrap.getAttribute('data-tcb-trust-badges-initial') || '4', 10);
      var hidden = Math.max(0, total - initial);
      toggle.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded
          ? 'View less'
          : 'View more (' + hidden + ')';
      });
    });
  }

  function initAccessories(root) {
    root.querySelectorAll('[data-tcb-accessories]').forEach(function (wrap) {
      if (wrap.getAttribute('data-bound') === '1') return;
      wrap.setAttribute('data-bound', '1');
      var toggle = wrap.querySelector('[data-tcb-accessories-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        toggle.textContent = expanded ? 'Show less' : 'Show more';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });

    bindQuickAddForms(root, '.tcb-accessory-add-form', '.tcb-accessory-add', '+ Add');
  }

  function initHighlightTabs(root) {
    var wrap = root.querySelector('[data-tcb-highlight-tabs]');
    if (!wrap || wrap.getAttribute('data-bound') === '1') return;
    wrap.setAttribute('data-bound', '1');

    var tabs = wrap.querySelectorAll('.tcb-highlight-tab');
    var panels = wrap.querySelectorAll('.tcb-highlight-panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-tab');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-panel') === id;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });
  }

  function initReadMore(root) {
    root.querySelectorAll('[data-tcb-read-more]').forEach(function (wrap) {
      if (wrap.getAttribute('data-bound') === '1') return;
      wrap.setAttribute('data-bound', '1');
      var btn = wrap.querySelector('[data-tcb-read-more-btn]');
      var body = wrap.querySelector('[data-tcb-read-more-body]');
      if (!btn || !body) return;
      btn.addEventListener('click', function () {
        var expanded = wrap.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show less' : 'Show more';
        btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  function initMiniBadgeLinks(root) {
    root.querySelectorAll('[data-tcb-scroll-target]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var target = document.querySelector(el.getAttribute('data-tcb-scroll-target'));
        if (!target) return;
        e.preventDefault();
        scrollToSection(target, {
          revealSpec: el.getAttribute('data-tcb-spec-reveal') === 'true'
        });
      });
    });
  }

  function scrollToSection(target, options) {
    if (!target) return;
    options = options || {};
    var acc = target.matches('[data-tcb-pdp-acc]') ? target : target.closest('[data-tcb-pdp-acc]');
    if (acc) acc.open = true;
    if (options.revealSpec) {
      target.classList.add('tcb-spec-section--revealed');
      var tableWrap = target.querySelector('.tcb-spec-v2__table-wrap, .tcb-spec-v2__layout, .tcb-spec-panel');
      if (tableWrap) tableWrap.classList.add('is-focused');
    }
    var nav = document.querySelector('[data-tcb-section-nav]');
    var navHeight = nav ? nav.offsetHeight : 0;
    var headerOffset = 72;
    var focusEl = options.revealSpec
      ? (target.querySelector('.tcb-spec-v2__table-wrap, .tcb-spec-v2__layout, .tcb-spec-panel') || target)
      : target;
    var y = focusEl.getBoundingClientRect().top + window.scrollY - navHeight - headerOffset;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    if (options.revealSpec) {
      window.setTimeout(function () {
        target.classList.add('tcb-spec-section--revealed');
        if (focusEl && typeof focusEl.focus === 'function') {
          focusEl.setAttribute('tabindex', '-1');
          focusEl.focus({ preventScroll: true });
        }
      }, 450);
    }
  }

  function resolveNavTarget(selector) {
    var target = document.querySelector(selector);
    if (target) return target;
    if (selector === '#tcb-pdp-reviews' || selector === '#judgeme_product_reviews') {
      return document.querySelector('#judgeme_product_reviews, .jdgm-widget, [id*="judge_me"]');
    }
    return null;
  }

  function initSectionNav(root) {
    var nav = root.querySelector('[data-tcb-section-nav]');
    if (!nav || nav.getAttribute('data-bound') === '1' || nav.getAttribute('data-tcb-nav-bound') === '1') return;
    nav.setAttribute('data-bound', '1');

    var links = nav.querySelectorAll('[data-tcb-nav-target]');
    if (!links.length) return;

    var sections = [];
    var headerOffset = 72;

    function setActiveLink(activeLink) {
      links.forEach(function (link) {
        link.classList.toggle('is-active', link === activeLink);
      });
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var selector = link.getAttribute('data-tcb-nav-target');
        var target = resolveNavTarget(selector);
        if (!target) return;
        e.preventDefault();
        setActiveLink(link);
        scrollToSection(target);
      });
      var target = resolveNavTarget(link.getAttribute('data-tcb-nav-target'));
      if (target) sections.push({ link: link, target: target });
    });

    function syncActiveFromScroll() {
      if (!sections.length) return;
      var navHeight = nav.offsetHeight || 0;
      var marker = window.scrollY + navHeight + headerOffset + 24;
      var active = sections[0];
      sections.forEach(function (item) {
        var top = item.target.getBoundingClientRect().top + window.scrollY;
        if (top <= marker) active = item;
      });
      setActiveLink(active.link);
    }

    var stuckObserver = new IntersectionObserver(function (entries) {
      nav.classList.toggle('is-stuck', !entries[0].isIntersecting);
    }, { threshold: 1, rootMargin: '-1px 0px 0px 0px' });
    var sentinel = document.createElement('div');
    sentinel.className = 'tcb-pdp-section-nav__sentinel';
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px;pointer-events:none;';
    nav.parentNode.insertBefore(sentinel, nav);
    stuckObserver.observe(sentinel);

    window.addEventListener('scroll', syncActiveFromScroll, { passive: true });
    window.addEventListener('resize', syncActiveFromScroll, { passive: true });
    syncActiveFromScroll();
  }

  function openTidioChat() {
    if (typeof window.tcbOpenTidioChat === 'function') {
      window.tcbOpenTidioChat();
      return true;
    }
    if (window.tidioChatApi && typeof window.tidioChatApi.open === 'function') {
      window.tidioChatApi.open();
      return true;
    }
    if (window.tidioChatApi && typeof window.tidioChatApi.display === 'function') {
      window.tidioChatApi.display(true);
      if (typeof window.tidioChatApi.open === 'function') window.tidioChatApi.open();
      return true;
    }
    document.dispatchEvent(new Event('tidioChat-open'));
    return false;
  }

  function initTidioChat() {
    /* Handled globally by tcb-tidio-chat.js */
  }

  function initUpsellForms(root) {
    bindQuickAddForms(root, '.tcb-upsell-add-form', '.tcb-upsell-add', '+ Add');
    bindQuickAddForms(root, '.tcb-fbt-add-form', '.tcb-fbt-add', 'Add to cart');
  }

  function initGlobalQuickAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches) return;
      if (!form.matches('.tcb-fbt-add-form, .tcb-upsell-add-form, .tcb-accessory-add-form')) return;
      if (form.getAttribute('data-bound') === '1') return;
      e.preventDefault();
      var btn = form.querySelector('.tcb-fbt-add, .tcb-upsell-add, .tcb-accessory-add');
      var resetLabel = btn && btn.classList.contains('tcb-upsell-add') ? '+ Add'
        : btn && btn.classList.contains('tcb-accessory-add') ? '+ Add'
        : 'Add to cart';
      tcbQuickAdd(form, btn, { resetLabel: resetLabel });
    }, true);
  }

  function initQuantity(root) {
    root.querySelectorAll('[data-tcb-qty]').forEach(function (wrap) {
      if (wrap.getAttribute('data-bound') === '1') return;
      wrap.setAttribute('data-bound', '1');
      var input = wrap.querySelector('.tcb-qty-input');
      var minus = wrap.querySelector('[data-tcb-qty-minus]');
      var plus = wrap.querySelector('[data-tcb-qty-plus]');
      if (!input) return;
      function setQty(next) {
        var val = Math.max(1, parseInt(next, 10) || 1);
        input.value = String(val);
      }
      if (minus) minus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty((parseInt(input.value, 10) || 1) + 1); });
    });
  }

  function initStickyAtc(root) {
    var bar = root.querySelector('[data-tcb-sticky-atc]');
    var panel = root.querySelector('[data-tcb-checkout-panel]');
    var mainAdd = root.querySelector('[data-tcb-add-btn]');
    var stickyAdd = root.querySelector('[data-tcb-sticky-add]');
    if (!bar || !panel || bar.getAttribute('data-bound') === '1') return;
    bar.setAttribute('data-bound', '1');

    function setVisible(show) {
      bar.hidden = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('tcb-sticky-atc-visible', show);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
      observer.observe(panel);
    }

    if (stickyAdd && mainAdd) {
      stickyAdd.addEventListener('click', function () {
        if (mainAdd.disabled) return;
        mainAdd.click();
        window.scrollTo({ top: panel.offsetTop - 80, behavior: 'smooth' });
      });
    }

    document.addEventListener('tcb:variant-change', function () {
      var priceEl = root.querySelector('[data-tcb-price-display]');
      var stickyPrice = root.querySelector('[data-tcb-sticky-price]');
      if (priceEl && stickyPrice) stickyPrice.textContent = priceEl.textContent;
    });
  }

  function initShare(root) {
    var modal = root.querySelector('[data-tcb-share-modal]');
    if (!modal || modal.getAttribute('data-bound') === '1') return;
    modal.setAttribute('data-bound', '1');

    var nativeWrap = modal.querySelector('[data-tcb-share-native-wrap]');
    var nativeBtn = modal.querySelector('[data-tcb-share-native]');
    if (nativeWrap && nativeBtn && navigator.share) {
      nativeWrap.hidden = false;
      nativeBtn.addEventListener('click', function () {
        var title = (root.querySelector('.tcb-buy-box h1') || {}).textContent || document.title;
        navigator.share({ title: title.trim(), url: window.location.href }).catch(function () {});
      });
    }

    function openShareModal() {
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tcb-share-modal-open');
      var closeBtn = modal.querySelector('.tcb-share-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeShareModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tcb-share-modal-open');
    }

    root.querySelectorAll('[data-tcb-share-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        openShareModal();
      });
    });

    modal.querySelectorAll('[data-tcb-share-close]').forEach(function (el) {
      el.addEventListener('click', closeShareModal);
    });

    var copyBtn = modal.querySelector('[data-tcb-share-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var url = copyBtn.getAttribute('data-share-url') || window.location.href;
        var label = copyBtn.querySelector('[data-tcb-share-copy-label]');
        function showCopied() {
          if (label) {
            var original = label.textContent;
            label.textContent = 'Link copied!';
            setTimeout(function () { label.textContent = original; }, 1800);
          }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showCopied).catch(function () {
            window.prompt('Copy this link:', url);
          });
        } else {
          window.prompt('Copy this link:', url);
          showCopied();
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) closeShareModal();
    });
  }

  function initSocialProofRotator(root) {
    var proof = root.querySelector('[data-tcb-social-proof]');
    if (!proof || proof.getAttribute('data-tcb-rotator') === '1') return;
    var lines = proof.querySelectorAll('[data-tcb-viewers],[data-tcb-carts],[data-tcb-stock]');
    if (!lines.length) return;
    proof.setAttribute('data-tcb-rotator', '1');
    var index = 0;
    function highlightLine() {
      lines.forEach(function (el, i) {
        el.classList.toggle('is-active', i === index);
      });
      index = (index + 1) % lines.length;
    }
    highlightLine();
    setInterval(highlightLine, 45000);
  }

  function hideTidioBubble() {
    if (window.tidioChatApi && typeof window.tidioChatApi.display === 'function') {
      window.tidioChatApi.display(false);
      return true;
    }
    return false;
  }

  function initFloatingActions() {
    var wrap = document.querySelector('[data-tcb-floating-actions]');
    if (!wrap || wrap.getAttribute('data-bound') === '1') return;
    wrap.setAttribute('data-bound', '1');

    var scrollTopBtn = wrap.querySelector('[data-tcb-scroll-top]');
    var chatBtn = wrap.querySelector('[data-tcb-floating-chat]');
    var revealY = 120;

    function updateVisibility() {
      var y = window.scrollY || document.documentElement.scrollTop || 0;
      var reveal = y > revealY;
      wrap.setAttribute('aria-hidden', reveal ? 'false' : 'true');
      wrap.classList.toggle('is-visible', reveal);
    }

    refreshCartCount();
    document.addEventListener('tcb:cart-updated', refreshCartCount);

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility, { passive: true });
    updateVisibility();

    if (scrollTopBtn) {
      scrollTopBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    if (chatBtn) {
      chatBtn.addEventListener('click', function () {
        if (typeof window.tcbOpenTidioChat === 'function') {
          window.tcbOpenTidioChat();
        } else {
          openTidioChat();
        }
      });
    }

    hideTidioBubble();
    document.addEventListener('tidioChat-ready', hideTidioBubble);
    var tidioPoll = setInterval(function () {
      if (hideTidioBubble()) clearInterval(tidioPoll);
    }, 400);
    setTimeout(function () { clearInterval(tidioPoll); }, 20000);
  }

  function initFbtBundle(root) {
    var bundle = root.querySelector('[data-tcb-fbt-bundle]');
    if (!bundle || bundle.getAttribute('data-tcb-fbt-bound') === '1') return;
    bundle.setAttribute('data-tcb-fbt-bound', '1');

    function formatMoney(cents) {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents);
      }
      return '$' + (Number(cents) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function getCardQuantity(card) {
      var input = card.querySelector('[data-tcb-fbt-qty]');
      var qty = input ? parseInt(input.value, 10) : 1;
      var min = input && input.min ? parseInt(input.min, 10) : 1;
      var max = input && input.max ? parseInt(input.max, 10) : 99;
      if (!Number.isFinite(qty) || qty < min) qty = min;
      if (qty > max) qty = max;
      if (input) input.value = String(qty);
      return qty;
    }

    function isCardSelected(card) {
      var check = card.querySelector('[data-tcb-fbt-check]');
      return !!(check && check.checked);
    }

    function selectedItems() {
      return Array.from(bundle.querySelectorAll('[data-tcb-fbt-item]')).filter(isCardSelected);
    }

    var addAll = bundle.querySelector('[data-tcb-fbt-add-all]');

    function updateTotal() {
      var totalWrap = bundle.querySelector('[data-tcb-fbt-total-value]');
      if (!totalWrap) return;
      var items = selectedItems();
      var total = items.reduce(function (sum, card) {
        return sum + Number(card.getAttribute('data-price') || 0) * getCardQuantity(card);
      }, 0);
      totalWrap.textContent = formatMoney(total);
      if (addAll) addAll.disabled = items.length === 0;
    }

    function bindQtyControls(card) {
      var input = card.querySelector('[data-tcb-fbt-qty]');
      if (!input) return;
      var dec = card.querySelector('[data-tcb-fbt-qty-dec]');
      var inc = card.querySelector('[data-tcb-fbt-qty-inc]');

      function clamp(val) {
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 99;
        return Math.min(max, Math.max(min, val));
      }

      function setQty(val) {
        input.value = String(clamp(val));
        updateTotal();
      }

      if (dec) {
        dec.addEventListener('click', function () {
          setQty(parseInt(input.value, 10) - 1);
        });
      }
      if (inc) {
        inc.addEventListener('click', function () {
          setQty(parseInt(input.value, 10) + 1);
        });
      }
      input.addEventListener('change', updateTotal);
      input.addEventListener('input', updateTotal);
    }

    bundle.querySelectorAll('[data-tcb-fbt-item]').forEach(function (card) {
      bindQtyControls(card);
    });

    bundle.querySelectorAll('[data-tcb-fbt-check]').forEach(function (checkbox) {
      checkbox.addEventListener('change', function () {
        var card = checkbox.closest('[data-tcb-fbt-item]');
        if (card) card.setAttribute('data-checked', checkbox.checked ? 'true' : 'false');
        updateTotal();
      });
    });

    updateTotal();

    if (!addAll) return;

    addAll.addEventListener('click', function () {
      var items = selectedItems().map(function (card) {
        return {
          id: Number(card.getAttribute('data-variant-id')),
          quantity: getCardQuantity(card),
        };
      }).filter(function (item) { return item.id; });

      if (!items.length) return;

      addAll.disabled = true;
      addAll.setAttribute('aria-busy', 'true');
      var original = addAll.innerHTML;
      addAll.textContent = 'Adding…';

      fetch(cartRoute('/cart/add.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && res.data.description) || 'Add failed');
          var itemCount = items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
          showCartToast('Bundle added to cart', itemCount + ' item' + (itemCount === 1 ? '' : 's') + ' added');
          notifyCartUpdated(addAll, itemCount);
        })
        .catch(function () {
          showCartToast('Could not add bundle', 'Some items may be unavailable. Try adding individually.');
        })
        .finally(function () {
          addAll.disabled = selectedItems().length === 0;
          addAll.removeAttribute('aria-busy');
          addAll.innerHTML = original;
        });
    });
  }

  function removeDescSectionFromHeading(heading) {
    if (!heading || !heading.parentNode) return;
    var tag = heading.tagName;
    var level = tag === 'H2' ? 2 : tag === 'H3' ? 3 : tag === 'H4' ? 4 : 0;
    var node = heading;
    heading.remove();
    while (node.nextSibling) {
      node = node.nextSibling;
      if (node.nodeType === 1) {
        var nextTag = node.tagName;
        if ((level === 2 && nextTag === 'H2') || (level === 3 && /^H[23]$/.test(nextTag)) || (level === 4 && /^H[234]$/.test(nextTag))) {
          break;
        }
        var remove = node;
        node = node.nextSibling;
        remove.remove();
        continue;
      }
      var text = (node.textContent || '').trim();
      if (text) {
        var removeText = node;
        node = node.nextSibling;
        removeText.remove();
        continue;
      }
      node = node.nextSibling;
    }
  }

  function initDescriptionPriceStrip(root) {
    root.querySelectorAll('[data-tcb-desc-body]').forEach(function (body) {
      body.querySelectorAll('.tcb-desc-section, section').forEach(function (section) {
        var heading = section.querySelector('h2, h3');
        if (heading && /\bprice\b/i.test(heading.textContent.trim())) {
          section.remove();
        }
        if (heading && /kit includes|included with this/i.test(heading.textContent.trim())) {
          section.remove();
        }
      });

      body.querySelectorAll('table tr').forEach(function (row) {
        var th = row.querySelector('th');
        if (th && /\b(price|current price|msrp|our price|tc b price|sale price|list price)\b/i.test(th.textContent.trim())) {
          row.remove();
        }
        var td = row.querySelector('td');
        if (td && /^\s*\$[\d,]+(\.\d{2})?\s*$/.test(td.textContent.trim()) && th && !th.textContent.trim()) {
          row.remove();
        }
      });

      body.querySelectorAll('h2, h3, h4').forEach(function (heading) {
        var title = heading.textContent.trim();
        if (/^price details$/i.test(title)) {
          var sibling = heading.nextElementSibling;
          heading.remove();
          if (sibling && (sibling.matches('table') || sibling.matches('.tcb-desc-table-wrap') || sibling.matches('div'))) {
            sibling.remove();
          }
        }
        if (/^kit includes$/i.test(title) || /^included with this/i.test(title)) {
          removeDescSectionFromHeading(heading);
        }
      });

      body.querySelectorAll('p, li').forEach(function (el) {
        var text = el.textContent.trim();
        if (/^(current price|price|msrp|our price|list price|sale price)\s*:?\s*\$[\d,]+(\.\d{2})?\s*$/i.test(text)) {
          el.remove();
        }
      });
    });
  }

  function initFreightAck(root) {
    var wrap = root.querySelector('[data-tcb-freight-ack-wrap]');
    var addBtn = root.querySelector('[data-tcb-requires-freight-ack]');
    var checkbox = root.querySelector('[data-tcb-freight-ack]');
    if (!wrap || !addBtn || !checkbox || wrap.getAttribute('data-bound') === '1') return;
    wrap.setAttribute('data-bound', '1');

    function syncAddState() {
      var variantBlocked = addBtn.getAttribute('data-variant-unavailable') === 'true';
      addBtn.disabled = variantBlocked || !checkbox.checked;
    }

    checkbox.addEventListener('change', syncAddState);
    document.addEventListener('tcb:variant-change', function (e) {
      var available = e.detail && e.detail.available !== false;
      addBtn.setAttribute('data-variant-unavailable', available ? 'false' : 'true');
      syncAddState();
    });
    syncAddState();
  }

  function boot() {
    var root = document.querySelector('.tcb-pro');
    if (!root) return;
    document.addEventListener('tcb:cart-updated', refreshCartCount);
    initGallery(root);
    initTrustModal(root);
    initAssuranceModal(root);
    initShippingLeadTimeSync(root);
    initTrustBadgesLoadMore(root);
    initAccessories(root);
    initQuantity(root);
    initFreightAck(root);
    initStickyAtc(root);
    initShare(root);
    initHighlightTabs(root);
    initReadMore(root);
    initMiniBadgeLinks(root);
    initSectionNav(root);
    initUpsellForms(root);
    initFbtBundle(root);
    initGlobalQuickAdd();
    initSocialProofRotator(root);
    initFloatingActions();
    initDescriptionPriceStrip(root);
    neutralizePaymentHashLinks(document);
    window.setTimeout(function () { neutralizePaymentHashLinks(document); }, 2000);
    window.setTimeout(function () { neutralizePaymentHashLinks(document); }, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
